/**
 * Opções de família de fonte compartilhadas entre tipografia global e Post-it.
 */

export const POST_IT_FONT_HANDWRITING = 'handwriting';

export const HANDWRITING_FONT_GOOGLE_URL =
  'https://fonts.googleapis.com/css2?family=Caveat:wght@400;700&family=Patrick+Hand&display=swap';

export const HANDWRITING_FONT_CSS = '"Patrick Hand", "Caveat", cursive, sans-serif';

export const SYSTEM_FONT_CSS =
  'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';

/** Mesmas opções da aba Tipografia global (Família da Fonte). */
export const COURSE_FONT_FAMILY_OPTIONS = [
  { value: '', labelKey: 'fontSystem', googleFontUrl: '', cssFamily: SYSTEM_FONT_CSS },
  {
    value: "'Inter', sans-serif",
    labelKey: 'fontInter',
    googleFontUrl: 'https://fonts.googleapis.com/css2?family=Inter:wght@400;700&display=swap',
    cssFamily: "'Inter', sans-serif",
  },
  {
    value: "'Roboto', sans-serif",
    labelKey: 'fontRoboto',
    googleFontUrl: 'https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap',
    cssFamily: "'Roboto', sans-serif",
  },
  {
    value: "'Outfit', sans-serif",
    labelKey: 'fontOutfit',
    googleFontUrl: 'https://fonts.googleapis.com/css2?family=Outfit:wght@400;700&display=swap',
    cssFamily: "'Outfit', sans-serif",
  },
];

/** Post-it: manuscrita (padrão) + opções globais de tipografia. */
export const POST_IT_FONT_FAMILY_OPTIONS = [
  {
    value: POST_IT_FONT_HANDWRITING,
    labelKey: 'postItFontHandwriting',
    googleFontUrl: HANDWRITING_FONT_GOOGLE_URL,
    cssFamily: HANDWRITING_FONT_CSS,
  },
  ...COURSE_FONT_FAMILY_OPTIONS,
];

export function googleFontUrlForFamilyValue(fontFamily) {
  const opt = COURSE_FONT_FAMILY_OPTIONS.find((o) => o.value === fontFamily);
  return opt?.googleFontUrl || '';
}

export function resolvePostItFontFamilyCss(content) {
  const val = content?.fontFamily;
  if (!val || val === POST_IT_FONT_HANDWRITING) return HANDWRITING_FONT_CSS;
  const opt = POST_IT_FONT_FAMILY_OPTIONS.find((o) => o.value === val);
  if (opt) return opt.cssFamily;
  return String(val);
}

/** URL do Google Fonts para o Post-it, omitindo se a tipografia global já carrega a mesma fonte. */
export function resolvePostItGoogleFontUrl(content, globalConfig) {
  const val = content?.fontFamily;
  const effectiveVal = !val || val === POST_IT_FONT_HANDWRITING ? POST_IT_FONT_HANDWRITING : val;
  const opt = POST_IT_FONT_FAMILY_OPTIONS.find((o) => o.value === effectiveVal);
  const url = opt?.googleFontUrl || '';
  if (!url) return '';
  if (globalConfig?.googleFontUrl && globalConfig.googleFontUrl === url) return '';
  if (effectiveVal !== POST_IT_FONT_HANDWRITING && globalConfig?.fontFamily === effectiveVal && globalConfig?.googleFontUrl) {
    return '';
  }
  return url;
}

/** Coleta URLs únicas de fontes usadas por widgets Post-it (pré-visualização no builder). */
export function collectPostItGoogleFontUrls(rows, globalConfig, headerWidgets = []) {
  const urls = new Set();
  const scanWidgets = (widgets) => {
    (widgets || []).forEach((w) => {
      if (w.type !== 'post-it') return;
      const url = resolvePostItGoogleFontUrl(w.content, globalConfig);
      if (url) urls.add(url);
    });
  };
  (rows || []).forEach((row) => {
    (row.columns || []).forEach((col) => {
      scanWidgets(col.widgets);
    });
  });
  scanWidgets(headerWidgets);
  return [...urls];
}
